import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import homePng from '@/shared/assets/png/home.png';
import uimsPng from '@/shared/assets/png/uims.png';
import { otherSysPathNameMap } from '@/shared/system';
import { Avatar } from 'antd';
import { isEmpty } from 'lodash-es';
import HeaderMessage from '../HeaderMessage';
import HeaderService from '../HeaderService';
import styles from './index.module.less';
import { SettingFilled } from '@ant-design/icons';
import { useSharedGlobalState } from '@/shared/hooks';
const HeaderMenuBtn = ({ to, icon, text, }) => {
    return (_jsxs("a", { onClick: () => {
            if (to === '/') {
                window.location.href = '/';
            }
            else {
                window.open(to);
            }
        }, children: [_jsx(Avatar, { size: 16, className: `grid-icon-mobile`, src: icon, alt: "avatar" }), _jsx("span", { style: { marginLeft: '6px', color: 'rgba(255, 255, 255, 0.9)' }, className: `grid-header-mobile ${styles.joiner}`, children: text })] }));
};
export const HeaderRight = ({ hasBase = true }) => {
    const uInfo = sessionStorage.getItem('USER_INFO');
    const use = JSON.parse(uInfo) || {};
    const { authLoginType: REACT_APP_SYS, 
    // @ts-ignore
    isShowService } = useSharedGlobalState();
    return (_jsxs("div", { className: styles.HeaderRight, children: [hasBase ? _jsx(HeaderMenuBtn, { to: '/', icon: homePng, text: "\u5DE5\u4F5C\u53F0" }) : null, !isEmpty(use.defaultCompId) && REACT_APP_SYS != 'GOV' ? (_jsx(HeaderMenuBtn, { to: otherSysPathNameMap.UimsOrg, icon: uimsPng, text: "\u4F01\u4E1A\u7BA1\u7406" })) : null, _jsx("div", { className: `grid-icon-mobile`, children: REACT_APP_SYS == 'GOV' ? (_jsx(_Fragment, { children: _jsxs("a", { onClick: () => {
                            window.open('/gov-setting/orgStructure/organization');
                        }, children: [_jsx(SettingFilled, { style: {
                                    backgroundColor: 'unset',
                                    color: 'rgba(255, 255, 255, 0.5)',
                                    width: '16px',
                                } }), _jsx("span", { style: { marginLeft: '6px', color: 'rgba(255, 255, 255, 0.9)' }, className: `grid-header-mobile  ${styles.joiner}`, children: "\u7CFB\u7EDF\u8BBE\u7F6E" })] }) })) : (_jsx(_Fragment, { children: _jsx(HeaderMessage, { textClass: styles.joiner }) })) }), _jsx("span", { children: REACT_APP_SYS != 'GOV' && isShowService && _jsx(HeaderService, { textClass: styles.joiner }) })] }));
};
